export default __webpack_public_path__ + "static/media/kevin mullin.db4d0a0e.jpg";